/** Pledge and release photos stay clear in view, up to 250 KB. */
export const PHOTO_MAX_BYTES = 250 * 1024;

/**
 * Compress a camera/file image to JPEG and keep decoded payload under maxBytes (default 2 KB).
 * Used for release customer + article photos on VPS A.
 */
export function readFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}

export async function compressImageFileUnder10Kb(file, maxBytes = PHOTO_MAX_BYTES) {
  if (!file || !file.type || !file.type.startsWith('image/')) {
    throw new Error('Please choose an image file (JPEG/PNG).');
  }
  const dataUrl = await readFileAsDataUrl(file);
  const img = new Image();
  await new Promise((resolve, reject) => {
    img.onload = resolve;
    img.onerror = () => reject(new Error('Could not read image.'));
    img.src = dataUrl;
  });

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  let w = img.naturalWidth || img.width;
  let h = img.naturalHeight || img.height;
  if (!(w > 0) || !(h > 0)) throw new Error('Invalid image dimensions.');

  let quality = 0.86;
  const maxSide = 1600;

  for (let attempt = 0; attempt < 32; attempt++) {
    const scale = Math.min(1, maxSide / Math.max(w, h));
    canvas.width = Math.max(1, Math.round(w * scale));
    canvas.height = Math.max(1, Math.round(h * scale));
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    const jpeg = canvas.toDataURL('image/jpeg', quality);
    const b64 = jpeg.split(',')[1];
    const approxBytes = Math.ceil((b64.length * 3) / 4);
    if (approxBytes <= maxBytes) return jpeg;
    quality *= 0.88;
    if (quality < 0.28) {
      w *= 0.82;
      h *= 0.82;
      quality = 0.55;
    }
  }
  throw new Error(`Could not compress under ${maxBytes} bytes. Try a darker/smaller photo or lower camera resolution.`);
}
